import { useState } from "react";
import { useNavigate } from "react-router-dom";
import QrScanner from "react-qr-barcode-scanner";
import jsQR from "jsqr";

const Scanner = () => {
  const [showCamera, setShowCamera] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [scanMessage, setScanMessage] = useState("");
  const [clientType, setClientType] = useState(""); // 👈 Added state for client type
  const navigate = useNavigate();

  // Handle Image Upload + QR Decode
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setScanMessage("Processing image...");

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0, canvas.width, canvas.height);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height);

        if (code) {
          console.log("QR Code Result (from image):", code.data);
          navigate("/renter-detail", { state: { qrResult: code.data, clientType } });
        } else {
          console.log("No QR code found in image.");
          setScanMessage("No QR code detected in image.");
        }
      };
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="p-6 bg-white shadow-md rounded-lg w-full max-w-md">
        <h2 className="text-lg font-semibold text-gray-800 mb-4 text-center">
          QR Code Penyewa
        </h2>

        {/* Select Customer Type */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2 text-center">
            Select Customer Type
          </label>
          <select
            className="w-full border rounded-md p-2 text-gray-700 focus:outline-none focus:ring focus:ring-blue-300"
            value={clientType}
            onChange={(e) => {
              setClientType(e.target.value);
              setScanMessage("");
            }}
          >
            <option value="">-- Choose Customer Type --</option>
            <option value="sewaClient">Sewa Client</option>
            <option value="airClient">Air Client</option>
          </select>
        </div>

        {/* Show scanner only after selecting type */}
        {clientType && (
          <>
            {/* Upload Box */}
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
              <label className="block cursor-pointer">
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
                />
                <div className="border p-3 rounded-md hover:bg-gray-100">
                  <span className="text-gray-700">Choose Image</span>
                </div>
              </label>
              <p className="text-sm text-gray-500 mt-2">Or drop an image to scan</p>
            </div>

            {/* Camera Scanner */}
            <p
              className="mt-4 text-blue-600 text-center cursor-pointer hover:underline"
              onClick={() => {
                setShowCamera(!showCamera);
                setIsScanning(true);
                setScanMessage("");
              }}
            >
              {showCamera ? "Close Camera" : "Scan using camera directly"}
            </p>

            {showCamera && (
              <div className="mt-4 border rounded-lg overflow-hidden">
                <QrScanner
                  onUpdate={(err, result) => {
                    if (err) {
                      if (
                        !err.message?.includes("No MultiFormat Readers") &&
                        !err.message?.includes("No MultiFormat Reader")
                      ) {
                        console.error("Camera scan error:", err);
                      }
                      return;
                    }

                    if (result) {
                      console.log("QR Code detected:", result.text);
                      setIsScanning(false);
                      setScanMessage("QR Code detected! Redirecting...");
                      navigate("/renter-detail", {
                        state: { qrResult: result.text, clientType },
                      });
                    }
                  }}
                  style={{ width: "100%" }}
                />
                {isScanning && (
                  <p className="text-center text-sm text-gray-500 mt-2 animate-pulse">
                    Scanning... Hold your QR code steady
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {/* Status Message */}
        {scanMessage && (
          <p className="mt-4 text-center text-gray-700">{scanMessage}</p>
        )}
      </div>
    </div>
  );
};

export default Scanner;
